exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-body[data-v-c2342c5e] {\n  margin-top: 20px;\n}\n.body-info[data-v-c2342c5e] {\n  background: rgba(0,0,0,0.08);\n  border-radius: 5px;\n  height: 40px;\n  padding: 10px 0 0 13px;\n  margin-left: 10px;\n  display: flex;\n  align-items: flex-start;\n  width: 800px;\n}\n.body-info-text[data-v-c2342c5e] {\n  margin-left: 10px;\n}\n", ""]);

// exports
